import React from "react";
import "./fliploader.css";

function FlipLoader() {
  return <span className="loader"></span>;
}

export default FlipLoader;
